<template>
  <div class="container-fluid">
    <div class="contents tournament">
      <h4 class="subtitle">
        <p class="badge-group">
          <span class="badge tourn-type">
            {{ tournament_type(tournamentinfo.tourtype_fk) }}
          </span>
          <span class="badge tourn-game-type">
            {{ game_type(tournamentinfo.gametype_fk) }}  
          </span>
        </p>
        <p class="tourn-title">
          {{ tournamentinfo.title }}
        </p>
        <p class="tourn-rank-type">
          {{ tournamentinfo.tour_rank_type | tour_rank_type }}
        </p>           
      </h4>
      <!-- <p class="info">{{ tournamentinfo.remark }}</p> -->
      <div class="row row-cols-1 row-cols-lg-auto gy-2 lh-sm">
        <div class="col text-date">
          <!-- 서비스 시간 -->
          {{ tournamentinfo.timezone_startdate | dateformat }} ~
          {{ tournamentinfo.timezone_enddate | dateformat }}
        </div>
      </div>
      <div>
        <p class="pt-4 text-subscript text-info" v-if="tournamentinfo.gametype_fk==9">
          <span class="material-icons-outlined">info</span>
          {{ $t("text.common.offline_scramble_txt") }}
        </p>  
      </div>
             
      <b-form
        @submit="onSubmit"
        class="filter-group row row-cols-2 row-cols-sm-auto g-2 mt-3"
      >
        <div class="col" v-if="tournamentinfo.gametype_fk==1">
          <select aria-label="" v-model="searchData.pagesize">
            <option value="10" selected>
              {{ $t("filter.common.sort_by_10") }}
            </option>
            <option value="50">{{ $t("filter.common.sort_by_50") }}</option>
            <option value="100">
              {{ $t("filter.common.sort_by_100") }}
            </option>
          </select>
        </div>
              
        <div class="col" v-if="tournamentinfo.tour_rank_type == '0'">
          <div class="input-group">
            <select
              class="form-select"
              aria-label="Select one"
              v-model="searchData.tour_rank_type"
            >
              <option value="1">
                {{ $t("text.common.low_gross") }}
              </option>
              <option value="2">
                {{ $t("text.common.low_net") }}
              </option>
            </select>
          </div>
        </div>

        <div class="col flex-grow-1 flex-sm-grow-0" v-if="tournamentinfo.gametype_fk==1">
          <div class="input-group">
            <select
              class="form-select"
              aria-label="Select one"
              name="gender"
              v-model="searchData.gender"
            >
              <option value="0">{{ $t("filter.common.total") }}</option>
              <option value="1">{{ $t("filter.common.male") }}</option>
              <option value="2">{{ $t("filter.common.female") }}</option>
            </select>
            <button
              class="btn btn-primary btn-lg icon-search"
              type="submit"
            ></button>
          </div>
        </div>
        <!-- <div class="col flex-fill">
          <ul class="tab-sub">
            <li
              v-if="
                tournamentinfo.tour_rank_type == 1 ||
                tournamentinfo.tour_rank_type == 0
              "
            >
              <a class="on">{{ $t("button.common.stroke") }}</a>
            </li>
            <li v-if="tournamentinfo.tour_rank_type == 2">
              <a class="on">{{ $t("button.common.stroke_handicap") }}</a>
            </li>
          </ul>
        </div> -->
      </b-form>
      <table class="table board toggle-xxl" v-if="tournamentinfo.gametype_fk==1">
        <thead>
          <tr
            v-if="
              (tournamentinfo.tour_rank_type == '0' &&
                searchData.tour_rank_type == '1') ||
              tournamentinfo.tour_rank_type == '1'
            "
          >
            <th class="col-auto d-lg-table-cell">
              {{ $t("title.common.ranking") }}
            </th>
            <th class="col-auto d-lg-table-cell">
              {{ $t("title.common.nickname") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.location") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.course") }}
            </th>
            <th class="col-auto d-none d-sm-table-cell">
              {{ $t("title.common.stroke_score") }}
            </th>
            <th class="col-auto d-none d-md-table-cell">
              {{ $t("title.common.no_of_play") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.standard_point") }}
            </th>
            <th
              class="col-auto d-none d-lg-table-cell"
              v-if="tournamentinfo.oom_point != 0"
            >
              {{ $t("title.common.oom_point") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
          <tr
            v-if="
              (tournamentinfo.tour_rank_type == '0' &&
                searchData.tour_rank_type == '2') ||
              tournamentinfo.tour_rank_type == '2'
            "
          >
            <th class="col-auto d-lg-table-cell">
              {{ $t("title.common.ranking") }}
            </th>
            <th class="col-auto d-lg-table-cell">
              {{ $t("title.common.nickname") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.location") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.course") }}
            </th>
            <th class="col-auto d-none d-sm-table-cell">
              {{ $t("title.common.low_net_score") }}<br><span class="text-blue">({{ $t("title.common.handi_score") }})</span>
            </th>
            <th class="col-auto d-none d-md-table-cell">
              {{ $t("title.tournament.no_of_play") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.standard_point") }}
            </th>
            <th
              class="col-auto d-none d-lg-table-cell"
              v-if="tournamentinfo.oom_point != 0"
            >
              {{ $t("title.common.oom_point") }}
            </th>
            <!-- <th class="col-auto d-none d-lg-table-cell">
            Final Score<br />(Correction value)
          </th> -->
            <th class="th-arrow"></th>
          </tr>
        </thead>

        <tbody
          v-if="
            (total_cnt > 0 &&
              tournamentinfo.tour_rank_type == '0' &&
              searchData.tour_rank_type == '1') ||
            (total_cnt > 0 && tournamentinfo.tour_rank_type == '1')
          "
        >
          <template v-for="(item, index) in items">
            <tr :key="index">
              <td class="col-auto d-lg-table-cell w-1">
                <strong class="text-black">{{
                  item.tournamentrankinfo.rank
                }}</strong>
              </td>
              <td class="col-auto d-lg-table-cell text-start">
                <MemberInfo
                  :nickname="item.tournamentrankinfo.nickname"
                  :playerno="item.tournamentrankinfo.playerno"
                  :member_img="item.tournamentrankinfo.member_img"
                  :badge_img="item.tournamentrankinfo.badge_img"
                />
              </td>
              <td class="col-auto d-none d-xl-table-cell shop-name">
                {{
                  item.tournamentrankinfo.shopinfo &&
                  item.tournamentrankinfo.shopinfo.shopname
                }}
              </td>
              <td class="col-auto d-none d-xxl-table-cell">
                <template v-for="(course, index_n) in item.coursescore">
                  <p :key="index_n + 'l1'">
                    {{ course.coursename }}
                  </p>
                </template>
              </td>
              <td class="col-auto d-none d-sm-table-cell">
                <template v-for="(course, index_n) in item.coursescore">
                  <p :key="index_n + 'l1'">
                    {{ course.strokescore }}
                  </p>
                </template>
              </td>
              <td
                class="col-auto d-none d-md-table-cell more text-red"
                @click="oneModalOpen(item.tournamentrankinfo.player_pk)"
              >
                {{ item.tournamentrankinfo.entrycnt | comma }}
                / {{ item.tournamentrankinfo.entrylimit | transToValue("∞") }}
              </td>
              <td class="col-auto d-none d-lg-table-cell text-point-sp">
                {{
                  item.tournamentrankinfo.standard_points | comma | suffix("P")
                }}
              </td>
              <td
                class="col-auto d-none d-lg-table-cell text-point-op"
                v-if="tournamentinfo.oom_point != 0"
              >
                {{ item.tournamentrankinfo.oom_points | comma | suffix("P") }}
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-xxl-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="7">
                <div class="toggle-content">
                  <div class="row d-xl-none">
                    <div class="col-4">{{ $t("title.common.location") }}</div>
                    <div class="col-8 shop-name">
                      {{
                        item.tournamentrankinfo.shopinfo &&
                        item.tournamentrankinfo.shopinfo.shopname
                      }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.course") }}
                    </div>
                    <div class="col-8">
                      <template v-for="(course, index_nm) in item.coursescore">
                        {{ index_nm > 0 ? " / " : "" }}
                        <span :key="index_nm + 'm'"
                          >{{ course.coursename }}
                        </span>
                      </template>
                    </div>
                  </div>
                  <div class="row d-sm-none">
                    <div class="col-4">
                      {{ $t("title.common.stroke_score") }}
                    </div>
                    <div class="col-8">
                      <template v-for="(course, index_nm) in item.coursescore">
                        {{ index_nm > 0 ? " / " : "" }}
                        <span :key="index_nm + 'm'">
                          {{ course.strokescore }}</span
                        >
                      </template>
                    </div>
                  </div>
                  <div class="row d-md-none">
                    <div class="col-4">
                      {{ $t("title.tournament.no_of_play") }}
                    </div>
                    <div
                      class="col-8 more text-red"
                      @click="oneModalOpen(item.tournamentrankinfo.player_pk)"
                    >
                      {{ item.tournamentrankinfo.entrycnt | comma }}
                      /
                      {{
                        item.tournamentrankinfo.entrylimit | transToValue("∞")
                      }}
                    </div>
                  </div>
                  <div class="row d-lg-none">
                    <div class="col-4">
                      {{ $t("title.common.standard_point") }}
                    </div>
                    <div class="col-8 text-point-sp">
                      {{
                        item.tournamentrankinfo.standard_points
                          | comma
                          | suffix("P")
                      }}
                    </div>
                  </div>
                  <div class="row d-lg-none" v-if="tournamentinfo.oom_point != 0">
                    <div class="col-4">
                      {{ $t("title.common.oom_point") }}
                    </div>
                    <div class="col-8 text-point-op">
                      {{ item.tournamentrankinfo.oom_points | comma }}P
                    </div>
                  </div>
                  <!-- <div class="row">
                  <div class="col-6">Final Score<br />(Correction value)</div>
                  <div class="col-6">
                    {{ item.tournamentrankinfo.newperiolastscore | comma }}
                  </div>
                </div> -->
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody
          v-else-if="
            (total_cnt > 0 &&
              tournamentinfo.tour_rank_type == '0' &&
              searchData.tour_rank_type == '2') ||
            (total_cnt > 0 && tournamentinfo.tour_rank_type == '2')
          "
        >
          <template v-for="(item, index) in items">
            <tr :key="index">
              <td class="col-auto d-lg-table-cell w-1">
                <strong class="text-black">{{
                  item.tournamentrankinfo.rank
                }}</strong>
              </td>
              <td class="col-auto d-lg-table-cell text-start">
                <MemberInfo
                  :nickname="item.tournamentrankinfo.nickname"
                  :playerno="item.tournamentrankinfo.playerno"
                  :member_img="item.tournamentrankinfo.member_img"
                  :badge_img="item.tournamentrankinfo.badge_img"
                />
              </td>
              <td class="col-auto d-none d-xl-table-cell shop-name">
                {{
                  item.tournamentrankinfo.shopinfo &&
                  item.tournamentrankinfo.shopinfo.shopname
                }}
              </td>
              <td class="col-auto d-none d-xxl-table-cell">
                <template v-for="(course, index_n) in item.coursescore">
                  <p :key="index_n + 'l1'">
                    {{ course.coursename }}
                  </p>
                </template>
              </td>
              <td class="col-auto d-none d-sm-table-cell">
                <template v-for="(course, index_n) in item.coursescore">
                  <p :key="index_n + 'l1'">
                    {{ course.low_net }} (<span class="text-blue">{{ hc_au(item.tournamentrankinfo.handicap_diff) }}</span>)
                  </p>
                </template>
              </td>
              <td
                class="col-auto d-none d-md-table-cell more text-red"
                @click="oneModalOpen(item.tournamentrankinfo.player_pk)"
              >
                {{ item.tournamentrankinfo.entrycnt | comma }} /
                {{ item.tournamentrankinfo.entrylimit | transToValue("∞") }}
              </td>
              <td class="col-auto d-none d-lg-table-cell text-point-sp">
                {{
                  item.tournamentrankinfo.standard_points | comma | suffix("P")
                }}
              </td>
              <td
                class="col-auto d-none d-lg-table-cell text-point-op"
                v-if="tournamentinfo.oom_point != 0"
              >
                {{ item.tournamentrankinfo.oom_points | comma | suffix("P") }}
              </td>
              <!-- <td class="col-auto d-none d-lg-table-cell">
              {{ item.tournamentrankinfo.newperiolastscore | comma }}
            </td> -->
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-xxl-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="7">
                <div class="toggle-content">
                  <div class="row d-xl-none">
                    <div class="col-4">{{ $t("title.common.location") }}</div>
                    <div class="col-8 shop-name">
                      {{
                        item.tournamentrankinfo.shopinfo &&
                        item.tournamentrankinfo.shopinfo.shopname
                      }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.course") }}
                    </div>
                    <div class="col-8">
                      <template v-for="(course, index_n) in item.coursescore">
                        <p :key="index_n + 'l1'">
                          {{ course.coursename }}
                        </p>
                      </template>
                    </div>
                  </div>
                  <div class="row d-sm-none">
                    <div class="col-4">
                      {{ $t("title.common.low_net_score") }}<br><span class="text-blue">({{ $t("title.common.handi_score") }})</span>
                    </div>
                    <div class="col-8">
                      <template v-for="(course, index_n) in item.coursescore">
                        <p :key="index_n + 'l1'">
                          {{ course.low_net }} (<span class="text-blue">{{ hc_au(item.tournamentrankinfo.handicap_diff) }}</span>)
                        </p>
                      </template>
                    </div>
                  </div>
                  <div class="row d-md-none">
                    <div class="col-4">
                      {{ $t("title.tournament.no_of_play") }}
                    </div>
                    <div
                      class="col-8 more text-red"
                      @click="oneModalOpen(item.tournamentrankinfo.player_pk)"
                    >
                      {{ item.tournamentrankinfo.entrycnt | comma }} /
                      {{
                        item.tournamentrankinfo.entrylimit | transToValue("∞")
                      }}
                    </div>
                  </div>
                  <div class="row d-lg-none">
                    <div class="col-4">
                      {{ $t("title.common.standard_point") }}
                    </div>
                    <div class="col-8 text-point-sp">
                      {{
                        item.tournamentrankinfo.standard_point
                          | comma
                          | suffix("P")
                      }}
                    </div>
                  </div>
                  <div 
                    class="row d-lg-none" 
                    v-if="tournamentinfo.oom_point != 0"
                  >
                    <div class="col-4">
                      {{ $t("title.common.oom_point") }}
                    </div>
                    <div class="col-8 text-point-op">
                      {{
                        item.tournamentrankinfo.oom_point | comma | suffix("P")
                      }}
                    </div>
                  </div>
                  <!-- <div class="row">
                  <div class="col-4">Final Score<br />(Correction value)</div>
                  <div class="col-8">
                    {{ item.tournamentrankinfo.newperiolastscore | comma }}
                  </div>
                </div> -->
                </div>
              </td>
            </tr>
          </template>
        </tbody>

        <tbody v-else>
          <tr>
            <td
              colspan="10"
              class="text-center"
              v-if="tournamentinfo.holecount > 9 || searchData.scoretype < 2"
            >
              {{ $t("text.common.no_data") }}
            </td>
            <td colspan="10" class="text-center" v-else>
              {{ $t("text.common.not_provided_9_hole_mode") }}
            </td>
          </tr>
        </tbody>
      </table>      
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="page_total"
        v-model="searchData.pageno"
        use-router
        aria-label="Page navigation example"
        v-if="page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <a v-if="active">{{ page }}</a>
          <a v-else>{{ page }}</a>
        </template>
      </b-pagination-nav>
      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="outline-primary"
          aria-label="list"
          @click="$router.push({ name: 'TournamentList' }).catch(() => {})"
          >{{ $t("button.common.list") }}</b-button
        >
      </div>
    </div>
    
    <b-modal
      id="modal-scorecard-individual"
      ref="modal-scorecard-individual"
      size="lg"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h5 class="modal-title" id="exampleModalLabel">{{ $t("title.common.scorecard_list") }}</h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$refs['modal-scorecard-individual'].hide()"
        ></b-button>
      </template>

      <table class="table board">
        <thead>
          <tr>
            <th class="d-lg-table-cell">
              {{ $t("title.common.course") }}
            </th>
            <th class="d-none d-lg-table-cell">
              {{ $t("title.common.shot") }}
            </th>
            <th class="d-none d-md-table-cell">
              {{ $t("title.common.date") }}
            </th>
            <th class="d-none d-sm-table-cell">
              {{ $t("title.membership.scorecard") }}
            </th>
            <th class="th-arrow">&nbsp;</th>
          </tr>
        </thead>
        <tbody v-if="scorecarditems.length > 0">
          <template v-for="(item, index) in scorecarditems">
            <tr :key="index">
              <td class="d-lg-table-cell text-start text-sm-center">
                {{ item.coursename }}
              </td>
              <td class="d-none d-lg-table-cell">
                {{ item.score | comma }}
              </td>
              <td class="d-none d-md-table-cell">
                <div class="col-auto text-date">
                  {{ item.timezone_startdate | dateformat }}
                </div>
              </td>
              <td class="d-none d-sm-table-cell">
                <button
                  type="button"
                  class="btn btn-outline-primary btn-xs"
                  @click="allModalOpen(item.player_pk, item.gameno)"
                >
                  {{ $t("button.membership.scorecard") }}
                </button>
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-lg-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="4">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.shot") }}
                    </div>
                    <div class="col-8">{{ item.score }}</div>
                  </div>

                  <div class="row d-md-none">
                    <div class="col-4">{{ $t("title.common.date") }}</div>
                    <div class="col-8">
                      <p class="text-date">
                        {{ item.timezone_startdate | dateformat }}
                      </p>
                    </div>
                  </div>

                  <div class="row d-sm-none">
                    <div class="col-4">
                      {{ $t("title.membership.scorecard") }}
                    </div>
                    <div class="col-8">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-xs"
                        @click="allModalOpen(item.player_pk, item.gameno)"
                      >
                        {{ $t("button.membership.scorecard") }}
                      </button>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="4" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>

      <template #modal-footer="{ cancel }">
        <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.cancel')"
          @click="cancel()"
          class="btn1"
        >
          {{ $t("button.common.cancel") }}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-scorecard-total"
      ref="modal-scorecard-total"
      size="xl"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h5 class="modal-title" id="exampleModalLabel">
          {{ $t("title.membership.scorecard") }}
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$refs['modal-scorecard-total'].hide()"
        ></b-button>
      </template>

      <scorecard
        v-bind:score-card-info="scorecardinfo"
        v-bind:score-card-stats="scorecardstats"
        v-bind:score-card-total="scorecardtotal"
        v-bind:score-card-hole-par="scorecardholepar"
        v-bind:score-card-score="scorecardscore"
        v-bind:sub-course-list="subcourselist"
      />

      <div class="row g-0 border-top-dgray" id="modal-scorecard-total">
        <div class="col-lg-6 border-bottom">
          <div class="row g-0">
            <div class="col bg-gray row g-0 align-item-center">
              <label class="align-center d-table-cell">
                {{ $t("title.common.max_distance") }}
              </label>
            </div>
            <div class="col d-flex">
              <p class="d-table-cell align-self-center">
                {{ scorecardstats.maxdriver }}m
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 border-bottom">
          <div class="row g-0">
            <div class="col bg-gray row g-0 align-item-center">
              <label class="align-center d-table-cell">
                {{ $t("title.common.avg_distance") }}
              </label>
            </div>
            <div class="col d-flex">
              <p class="d-table-cell align-self-center">
                {{ scorecardstats.avgdriver }}m
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 border-bottom">
          <div class="row g-0">
            <div class="col bg-gray row g-0 align-item-center">
              <label class="d-table-cell"
                >{{ $t("title.common.score") }}({{
                  $t("title.common.shot")
                }})</label
              >
            </div>
            <div class="col d-flex">
              <p class="d-table-cell align-self-center">
                <!-- {{
                      Math.sign(
                        scorecardstats.score - scorecardstats.base_par
                      ) > 0
                        ? "+"
                        : ""
                    }}{{ scorecardstats.score - scorecardstats.base_par }} -->
                {{
                  Math.sign(scorecardstats.score - scorecardstats.base_par) > 0
                    ? "+"
                    : ""
                }}{{ scorecardstats.score - scorecardstats.base_par }}
                <small>({{ scorecardstats.score }}) </small>
                <!-- ( {{ scorecardtotal.mulligantotal || 0 }} ) -->
                <!-- {{ scorecardtotal.mulligantotal ? "(" || "" : "" }}
                    {{ scorecardtotal.mulligantotal }}
                    {{ scorecardtotal.mulligantotal ? ")" || "" : "" }} -->
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 border-bottom">
          <div class="row g-0">
            <div class="col bg-gray row g-0 align-item-center">
              <label class="align-center d-table-cell">
                {{ $t("title.common.avg_putts_distance") }}
              </label>
            </div>
            <div class="col d-flex">
              <p class="d-table-cell align-self-center">
                {{ scorecardstats.avggreenhit | toFixed }}m
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 border-bottom">
          <div class="row g-0">
            <div class="col bg-gray row g-0 align-item-center">
              <label class="align-center d-table-cell">{{
                $t("title.common.fareway_hit")
              }}</label>
            </div>
            <div class="col d-flex">
              <p class="d-table-cell align-self-center">
                {{ scorecardstats.farewayrate }}%
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 border-bottom">
          <div class="row g-0">
            <div class="col bg-gray row g-0 align-item-center">
              <label class="align-center d-table-cell">{{
                $t("title.common.gir")
              }}</label>
            </div>
            <div class="col d-flex">
              <p class="d-table-cell align-self-center">
                {{ scorecardstats.greenrate }}%
              </p>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.cancel')"
          @click="cancel()"
        >
          {{ $t("button.common.cancel") }}
        </b-button>
      </template>
    </b-modal>    
  </div>
</template>

<script>
import ax from "@/api/tournament";
import "@/filter/common";
import { myMixin } from "@/mixin/myMixin";
import scorecard from "@/components/Scorecard";

export default {
  name: "TournamentRank",
  components: {
    scorecard,
  },
  data() {
    return {
      searchData: {
        tournamentno: this.$route.params.tournamentno || 0,
        scoretype: this.$route.query.scoretype || 1,
        gender: this.$route.query.gender || 0,
        pageno: this.$route.query.pageno || 1,
        pagesize: this.$route.query.pagesize || 10,
        tour_rank_type: this.$route.params.tour_rank_type || "1",
      },
      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 20,
      items: [],
      scorecarditems: [],
      view_hide: null,
      tournamentname: "",
      playerbasicinfo: [],
      playerpalyinfo: [],
      tournamentinfo: {},
      scorecardinfo: {},
      scorecardstats: {},
      scorecardholepar: [],
      scorecardscore: [],
      // partotal1, partotal2, shottotal1, shottotal2, scoretotal1, scoretotal2, mulligantotal1, mulligantotal2, mulligantotal
      scorecardtotal: {
        partotal1: 0,
        partotal2: 0,
        shottotal1: 0,
        shottotal2: 0,
        scoretotal1: 0,
        scoretotal2: 0,
        mulligantotal1: 0,
        mulligantotal2: 0,
        mulligantotal: 0,
      },

      subcourselist: [],
      subcourselistcnt: 0,
    };
  },
  watch: {
    "searchData.pagesize": function () {
      this.searchData.pageno = 1;
      this.get_ownertournamentranklist();
    },
    "searchData.scoretype": function () {
      this.searchData.pageno = 1;
      this.get_ownertournamentranklist();
    },
    "searchData.gender": function () {
      this.searchData.pageno = 1;
      this.get_ownertournamentranklist();
    },
    "searchData.tour_rank_type": function () {
      this.searchData.pageno = 1;
      this.get_ownertournamentranklist();
    },
    "searchData.pageno": function () {
      this.get_ownertournamentranklist();
    },
  },

  methods: {
    allModalOpen(player_pk, gameNo) {
      ax.get_memberscorecard(player_pk, gameNo, (flag, data) => {
        if (flag) {
          this.scorecardinfo = data.scorecardinfo;

          this.scorecardstats = data.scorecardstats;
          this.scorecardholepar = data.scorecardholepar;
          this.scorecardscore = data.scorecardscore;
          this.scorecardtotal = data.scorecardtotal;
          this.subcourselist = data.subcourselist;
          this.subcourselistcnt = data.subcourselistcnt;
          this.$refs["modal-scorecard-total"].show();
        } else {
          alert(data.message);
        }
      });
    },
    oneModalOpen(player_pk) {
      ax.get_admintournamentplaylist(
        this.searchData.tournamentno,
        player_pk,
        (flag, data) => {
          if (flag) {
            this.scorecarditems = data.tournamentplaylist;

            this.$refs["modal-scorecard-individual"].show();
          } else {
            alert(data.message);
          }
        }
      );
    },
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
    },
    change_type(type) {
      this.searchData.scoretype = type;
      this.searchData.pageno = 1;
      this.view_hide = null;
    },
    get_ownertournamentranklist() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.get_ownertournamentranklist(this.searchData, (flag, data) => {
        if (flag) {
          this.total_cnt = data.tournamentranklistcnt;
          this.page_total = Math.ceil(
            data.tournamentranklistcnt / this.searchData.pagesize
          );
          this.items = data.tournamentranklist;
          this.tournamentinfo = data.tournamentinfo;
        } else {
          this.data_yn = false;
          this.page_total = 0;
          // alert(data);
        }
      });
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
  created() {
    this.get_ownertournamentranklist();
  },
  mixins: [myMixin],
};
</script>
